module.exports = __webpack_public_path__ + "static/media/html-icon.fe69b77f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/html-icon.webp
// module id = 246
// module chunks = 1